import React from 'react';
export default /*#__PURE__*/React.forwardRef(function CardFrontFace({
  children,
  cardFace
}, ref) {
  return /*#__PURE__*/React.createElement("div", {
    className: `card-front-face${cardFace === 2 ? ' init' : ''}`,
    ref: ref
  }, children);
});